var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 2.67871H1.60714C0.719541 2.67871 0 3.39825 0 4.28585V13.393C0 14.2806 0.719541 15.0001 1.60714 15.0001H10.7143C11.6019 15.0001 12.3214 14.2806 12.3214 13.393V4.28585C12.3214 3.39825 11.6019 2.67871 10.7143 2.67871Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3935 1.03774e-09H3.7507C2.8679 -3.13885e-05 2.15033 0.712039 2.14355 1.59481C2.14355 1.59911 2.14355 1.60284 2.14355 1.60714H10.715C12.1936 1.6089 13.3918 2.8071 13.3935 4.2857V12.8571C13.3978 12.8571 13.4016 12.8571 13.4059 12.8571C14.2887 12.8504 15.0007 12.1328 15.0007 11.25V1.60714C15.0007 0.719541 14.2811 1.03774e-09 13.3935 1.03774e-09Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.1703ec724c9109ba2df452a97ef59a47.svg";
export { ForwardRef as ReactComponent };